import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { ContentContainer } from '@/components';
import { OfferRecord } from '@/components';
const mapStateToProps = (rootState) => ({
    _state: rootState.realtimeMonitoring,
});
class OfferRecordTable extends Component {
    constructor(props) {
        super(props);
        this.getAuctionMode = () => {
            const { auctionMode } = this.props._state.topCarDetails;
            return auctionMode === 1011 || auctionMode === 1021; // 超级拍-现场拍 & 超级拍-车道拍
        };
    }
    render() {
        const { highestPriceStage } = this.props._state;
        const isSuperAuction = this.getAuctionMode();
        return (<>
        {!isSuperAuction && (<div style={{ fontSize: '20px', color: '#1a1a1a', marginLeft: '70px' }}>竞拍出价记录</div>)}
        <ContentContainer>
          <OfferRecord id={this.props.id} tabCustomFn={({ tabType, tabTitle }) => {
            return (<div style={{ position: 'relative' }}>
                  <p>{tabTitle}</p>
                  {highestPriceStage === tabType &&
                <p style={{
                    position: 'absolute',
                    right: '-28px',
                    top: '-8px',
                    width: '36px',
                    height: '18px',
                    backgroundColor: '#ff4949',
                    borderRadius: '100px',
                    fontSize: '12px',
                    color: '#fff',
                    textAlign: 'center',
                }}>
                      最高
                    </p>}
                </div>);
        }}/>
        </ContentContainer>
      </>);
    }
}
export default connect(mapStateToProps)(OfferRecordTable);
